import { motion } from 'framer-motion';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface FeedbackInviteModalProps {
  open: boolean;
  onAccept: () => void;
  onDismiss: () => void;
}

export function FeedbackInviteModal({ open, onAccept, onDismiss }: FeedbackInviteModalProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onDismiss(); }}>
      <DialogContent
        hideClose
        className="max-w-sm rounded-3xl p-0 overflow-x-hidden overflow-y-auto border-0"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogTitle className="sr-only">Feedback Invite</DialogTitle>

        <motion.div
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          {/* Banner image */}
          <img loading="lazy" decoding="async"
            src="/images/early-access-reward.jpg"
            alt="Early Access Reward"
            className="w-full rounded-t-3xl"
          />

          {/* Content */}
          <div className="p-5 space-y-4 text-center">
            <div className="space-y-2">
              <h2 className="text-xl font-bold text-foreground">
                Got 1 minute?
              </h2>
              <p className="text-sm text-muted-foreground">
                Share your feedback and unlock{' '}
                <span className="font-bold text-orange-500">Early Access</span>{' '}
                to new scripts, guides &amp; features
              </p>
            </div>

            <div className="space-y-3">
              <Button
                onClick={onAccept}
                className="w-full rounded-xl font-bold bg-orange-500 hover:bg-orange-600 text-white"
              >
                Let's go!
              </Button>
              <Button
                variant="ghost"
                onClick={onDismiss}
                className="w-full rounded-xl text-muted-foreground"
              >
                Not now
              </Button>
            </div>
          </div>
        </motion.div>
      </DialogContent>
    </Dialog>
  );
}
